import React from 'react';
import { ListRenderItem } from 'react-native';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import HeroCard from '@src/components/HeroCard';
import RefreshControl from '@src/components/RefreshControl';
import { H1 } from '@src/components/Typography';
import { padding, windowWidth } from '@src/configuration/constants';
import { Suggestion } from '@src/types';

import { SuggestionList } from './styled';
import useUserSuggestions from './useUserSuggestions';

type Props = {};

const Container = styled.View`
  margin: ${padding}px auto;
  max-width: ${windowWidth}px;
`;

const Title = styled(H1)`
  padding: 5px ${padding}px;
`;

export const FriendsSuggestion: React.FC<Props> = () => {
  const {
    data,
    refreshing,
    handleEndReached,
    handleRefresh,
  } = useUserSuggestions();

  const renderItem: ListRenderItem<Suggestion> = React.useCallback(
    ({ item }) => <HeroCard item={item.user} />,
    []
  );

  return (
    <Container>
      <Title>
        <Trans>Friend Suggestion</Trans>
      </Title>
      <SuggestionList
        data={data}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={handleRefresh} />
        }
        initialNumToRender={data.length}
        onEndReached={handleEndReached}
        renderItem={renderItem}
      />
    </Container>
  );
};
